export function normalizeWebUrl(url) {
  const value = (url || "").toString().trim();
  if (!value) return "";
  if (/^http:\/\//i.test(value)) return value.replace(/^http:\/\//i, "https://");
  if (/^[a-z][a-z0-9+.-]*:/i.test(value)) return value;
  if (value.startsWith("//")) return `https:${value}`;
  return `https://${value}`;
}

export function buildVCard(card) {
  const esc = (s) =>
    (s || "")
      .toString()
      .replace(/\\/g, "\\\\")
      .replace(/,/g, "\\,")
      .replace(/;/g, "\\;")
      .replace(/\n/g, "\\n");

  const lines = [
    "BEGIN:VCARD",
    "VERSION:3.0",
    `N:${esc(card.last_name)};${esc(card.first_name)};;;`,
    `FN:${esc(card.first_name)} ${esc(card.last_name)}`,
  ];

  if (card.company) lines.push(`ORG:${esc(card.company)}`);
  if (card.job_title) lines.push(`TITLE:${esc(card.job_title)}`);
  if (card.work_phone) lines.push(`TEL;TYPE=WORK:${card.work_phone}`);
  if (card.cell_phone) lines.push(`TEL;TYPE=CELL:${card.cell_phone}`);
  if (card.email) lines.push(`EMAIL:${card.email}`);
  const website = normalizeWebUrl(card.website);
  if (website) lines.push(`URL:${website}`);

  lines.push("END:VCARD");

  return lines.join("\r\n");
}

export function downloadVCard(card) {
  const content = buildVCard(card);
  const blob = new Blob([content], { type: "text/vcard;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${card.slug || card.full_name || "contact"}.vcf`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
